type ProjectedLink = {
  linkType: "internal" | "external" | "anchor";
  anchorId: string | null;
  queryString: string | null;
  openInNewTab: boolean | null;
  disableUnderline: boolean;
  url: string | null;
};

export const externalLink = (
  url: string | null,
  options?: Partial<
    Pick<ProjectedLink, "openInNewTab" | "disableUnderline" | "queryString">
  >,
): ProjectedLink => ({
  linkType: "external",
  anchorId: null,
  queryString: options?.queryString ?? null,
  url,
  openInNewTab: options?.openInNewTab ?? false,
  disableUnderline: options?.disableUnderline ?? false,
});

export const internalLink = (
  url: string | null,
  options?: Partial<
    Pick<ProjectedLink, "openInNewTab" | "disableUnderline" | "queryString">
  >,
): ProjectedLink => ({
  linkType: "internal",
  anchorId: null,
  queryString: options?.queryString ?? null,
  url,
  openInNewTab: options?.openInNewTab ?? null,
  disableUnderline: options?.disableUnderline ?? false,
});
